<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-button style="padding: 0; margin: 20px" type="text" icon="el-icon-back" @click="backPrePage()">返回
        </el-button>
        <el-button type="primary" size="mini" @click="getList()">查询</el-button>
        <el-button type="primary" size="mini" @click="gotoInfo(0)">增加</el-button>
      </el-row>

      <el-table :data="listData" style="width: 100%" border size="mini" v-loading="listLoading">
        <el-table-column prop="target_id" label="秒杀ID" width="90"></el-table-column>
        <el-table-column prop="title" label="商品标题"></el-table-column>
        <el-table-column label="商品图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 66px; " alt=""/>
          </template>
        </el-table-column>

        <el-table-column label="秒杀价" align="center">
          <template slot-scope="{ row }">
            <div><p style="text-decoration:line-through">{{ row.price }}</p>{{ row.flash_sale_price }}</div>
          </template>
        </el-table-column>

        <el-table-column label="秒杀状态" align="center">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.flash_sale_status == 1" style="color: #67c23a"><i class="el-icon-circle-check"></i> 秒杀已上架</span>
              <span v-else style="color: #909399"><i class="el-icon-circle-close"></i> 秒杀未上架</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="有效期" align="center">
          <template slot-scope="{ row }">
            起：{{ row.begin_at }}<br />
            止：{{ row.end_at }}
          </template>
        </el-table-column>

        <el-table-column label="排序" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.item_status == 1" style="color: #67c23a"><i class="el-icon-circle-check"></i> 已发布</span>
              <span v-else style="color: #909399"><i class="el-icon-circle-close"></i> 未发布</span>
              <el-button type="text" size="small" style="margin-left: 5px"
                         @click=" row.item_status == 1 ? updateOnline(row.id, 'offline') : updateOnline(row.id, 'online')">
                {{ row.item_status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="primary" size="small" @click="gotoInfo(row.id)">修改</el-button>
            <el-button type="danger" size="small" @click="deleteInfo(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getFlashSaleList, updateFlashSaleSort, updateFlashSaleOnline, deleteFlashSaleInfo
} from "@/api/mall";

export default {
  data: function () {
    return {
      bannerTargetList: [],
      listData: [],
      listLoading: false,
      listTotal: 0,
      query: {
        limit: 20,
        page: 1
      },
      module_id:0
    }
  },
  created: function () {
    this.module_id = this.$route.query.module_id;
    this.getList();
  },
  methods: {
    filterBannerTarget(target) {
      return this.bannerTargetList[target];
    },
    getList() {
      this.listLoading = true;
      getFlashSaleList(this.query).then(response => {
        this.listData = response.data.list
        this.listTotal = response.data.total
        this.listLoading = false;
      });
    },
    deleteInfo(id) {
      this.$confirm('此操作将删除活动信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        deleteFlashSaleInfo({id}).then(response => {
          this.listLoading = false;
          if (response.code == 1) {
            this.getList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
    },
    updateSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
          .then(({value}) => {
            updateFlashSaleSort({
              id: id,
              sort: value,
            }).then((response) => {
              if (response.status == 2000) {
                this.getList();
                this.$message({
                  showClose: true,
                  message: "设置成功",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
          });
    },
    gotoInfo(id) {
      this.$router.push({
        path: "/mall/home/v2/flashSaleInfo",
        query: {
          id: id,
          module_id: this.module_id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    updateOnline(id, type) {
      this.listLoading = true;
      updateFlashSaleOnline({id, type}).then(response => {
        this.listLoading = false;
        if (response.code == 1) {
          this.getList();
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
        }
      });
    },
    backPrePage() {
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.el-button {
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>